export default __webpack_public_path__ + "static/media/img-o-n-4-free-tshirt.b80e6f6c.png";